/* CCC Courier theme v1.3.3 — the van mascot drives back and forth along the
   bottom of the screen by itself. It stops at each end, waves, turns round and
   sometimes offers a WhatsApp chat. Hovering or focusing it makes it stop.
   Visitors who turn off animations see it parked; anyone can hide it. */
(function () {
  'use strict';

  var root = document.querySelector('[data-van-mascot][data-van-auto]');
  if (!root || root.dataset.ready) return;
  /* Claim it before the older scroll-driven code in theme.js runs */
  root.dataset.ready = 'true';

  var store = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* ignore */ } }
  };
  if (store.get('ccc-van-hidden') === '1') return;

  function start() {
    var rider = root.querySelector('[data-van-rider]');
    var closeBtn = root.querySelector('[data-van-close]');
    if (!rider) return;
    root.hidden = false;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var x = -rider.offsetWidth - 20;   /* start just off screen, drive in */
    var dir = 1;                       /* 1 = right, -1 = left */
    var state = 'drive';               /* drive | pause */
    var held = false;                  /* hovered or focused */
    var stops = 0;
    var last = 0;
    var pauseUntil = 0;
    var timers = [];

    function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
    function track() { return Math.max(0, root.clientWidth - rider.offsetWidth - (window.innerWidth >= 750 ? 48 : 28)); }
    function speed() { return window.innerWidth >= 750 ? 80 : 46; } /* px per second */

    function place() {
      rider.style.transform = 'translateX(' + Math.round(x) + 'px)';
      root.classList.toggle('is-right', x > root.clientWidth / 2);
    }

    function talk(ms) {
      root.classList.add('is-talking');
      later(function () { if (!held) root.classList.remove('is-talking'); }, ms);
    }

    function wave() {
      root.classList.add('is-waving');
      later(function () { root.classList.remove('is-waving'); }, 2400);
    }

    function arrive(now) {
      state = 'pause';
      stops += 1;
      root.classList.remove('is-moving');
      wave();
      /* Offer a chat at the first stop, then every third stop */
      var chatty = stops === 1 || stops % 3 === 0;
      if (chatty) talk(5200);
      pauseUntil = now + (chatty ? 6000 : 2600);
    }

    function turn() {
      dir = -dir;
      root.classList.toggle('is-facing-left', dir === -1);
    }

    function frame(now) {
      if (!last) last = now;
      var dt = Math.min(0.05, (now - last) / 1000);
      last = now;

      if (!held && !document.hidden) {
        if (state === 'drive') {
          var end = track();
          x += dir * speed() * dt;
          if (dir === 1 && x >= end) { x = end; arrive(now); }
          else if (dir === -1 && x <= 0) { x = 0; arrive(now); }
          place();
        } else if (state === 'pause' && now >= pauseUntil) {
          turn();
          state = 'drive';
          root.classList.add('is-moving');
        }
      }
      requestAnimationFrame(frame);
    }

    if (reduce) {
      x = 0;
      place();
      root.classList.add('is-still');
      if (store.get('ccc-van-greeted') !== '1') { store.set('ccc-van-greeted', '1'); talk(6000); }
    } else {
      place();
      root.classList.add('is-moving');
      requestAnimationFrame(frame);
    }

    function hold() {
      held = true;
      root.classList.remove('is-moving');
      root.classList.add('is-talking', 'is-waving');
    }
    function release() {
      held = false;
      root.classList.remove('is-talking', 'is-waving');
      if (state === 'drive' && !reduce) root.classList.add('is-moving');
      last = 0;
    }
    rider.addEventListener('mouseenter', hold);
    rider.addEventListener('mouseleave', release);
    rider.addEventListener('focusin', hold);
    rider.addEventListener('focusout', function (e) { if (!rider.contains(e.relatedTarget)) release(); });

    window.addEventListener('resize', function () { x = Math.min(x, track()); place(); });

    if (closeBtn) closeBtn.addEventListener('click', function () {
      store.set('ccc-van-hidden', '1');
      held = true;
      timers.forEach(clearTimeout);
      root.classList.add('is-leaving');
      setTimeout(function () { root.hidden = true; }, 600);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
